import React from 'react';
import { Base } from 'src/components/';

const Loading = ({ message, loading = true, classes = 'w-full mx-auto' }) => (
  <div className=' max-w-1240 w-full mx-auto'>
    <div className={classes}>
      <div className='flex flex-col items-center h-32 -mb-18 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500' />

      <Base
        variant='transparent'
        classes='text-center pb-20 pt-20 mt-4'
        loading={loading}
      >
        <p>{message ? message.toString() : 'Loading..'}</p>
      </Base>
    </div>
  </div>
);

export default Loading;
